import { useLayoutEffect, useRef, type TableHTMLAttributes, type ReactElement } from 'react';

export function ResponsiveTable({ children, className = '', ...props }: TableHTMLAttributes<HTMLTableElement>): ReactElement {
  const ref = useRef<HTMLTableElement>(null);
  useLayoutEffect(() => {
    const table = ref.current;
    if (!table) return;
    const labels = Array.from(table.querySelectorAll('thead th')).map((header) => header.textContent?.replace(/[↑↓]/g, '').trim() || 'Actions');
    table.querySelectorAll('tbody tr').forEach((row) => {
      Array.from(row.children).forEach((cell, index) => {
        if (cell instanceof HTMLTableCellElement && cell.colSpan === 1) cell.setAttribute('data-label', labels[index] ?? 'Details');
      });
    });
  }, [children]);
  return <table {...props} ref={ref} className={`responsive-admin-table ${className}`}>{children}</table>;
}
